import FeatureBox from './FeatureBox'

export default FeatureBox
